import React from "react";
import propTypes from "prop-types";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "pages/Home";
import SearchOrgList from "pages/SearchOrgList";
import SearchClinksOrgDetails from "pages/SearchClinksOrgDetails";
import PageNotFound from "pages/PageNotFound";
import { DOMAIN_MTC } from "constants/app";
import { getStorageData } from "utils/helper";

const RoutesAll = (props) => {
  const domain = getStorageData("domain");

  return (
    <Router>
      <Routes>
        {DOMAIN_MTC === domain && (
          <Route path="/clinks-list" element={<SearchOrgList {...props} />} />
        )}
        <Route
          path="/clinks-details/:agency_id"
          element={<SearchClinksOrgDetails {...props} />}
        />
        <Route path="/" element={<Home {...props} />} />
        <Route path="/*" element={<PageNotFound {...props} />} />
      </Routes>
    </Router>
  );
};

RoutesAll.propTypes = {
  location: propTypes.object.isRequired,
  match: propTypes.object.isRequired,
};

export default RoutesAll;
